import Request from 'superagent';
import RequestMethod from './RequestMethod';
import config from './../lib/config';
import selectn from 'selectn';
import objectToQuerystring from './../lib/objectToQuerystring';
import isNullOrWhitespace from "./isNullOrWhitespace";

function request(options) {
    options.method = options.method || RequestMethod.Get;
    options.url = options.url || '';
    options.headers = options.headers || {};
    options.params = options.params || {};
    options.data = options.data || {};

    interpolateUrl(options);
    addXsrfToken(options);
    addContentType(options);
    appendSearchParams(options);

    return new Promise(function (resolve, reject) {
        const req = makeRequest(Request, options);

        req
            .end((err, response) => {
                if (err) {
                    reject(err);
                } else {
                    // const location = getLocation(options.method, response);

                    resolve(response.body || response.text);
                }
            });
    });
}

function getLocation(method, response) {
    if (method !== RequestMethod.Put) {
        return null;
    }

    return selectn('header.location', response);
}

function appendSearchParams(options) {
    const queryString = objectToQuerystring(options.params);

    if (!isNullOrWhitespace(queryString)) {
        options.url += '?' + queryString;
    }

    return options;
}

function interpolateUrl(options) {
    options.url = options.url.replace(
        /:([a-zA-Z]+[\w-]*)/g,
        ($0, token) => {
            // Try to move matching token from the params collection.
            if (options.params.hasOwnProperty(token)) {
                return (extractValue(options.params, token));
            }
            // Try to move matching token from the data collection.
            if (options.data.hasOwnProperty(token)) {
                return (extractValue(options.data, token));
            }
            // If a matching value couldn't be found, just replace
            // the token with the empty string.
            return ("");
        }
    );

    // Clean up any repeating slashes.
    options.url = options.url.replace(/(?:[^:])\/{2,}/g, "/");

    // Clean up any trailing slashes.
    options.url = options.url.replace(/\/+$/g, "");

    if (!/^https?:\/\//.test(options.url)) {
        options.url = config.apiServiceBaseUri + options.url;
    }

    return options;
}

function extractValue(collection, key) {
    var value = collection[key];
    delete (collection[key]);
    return value;
}

function addXsrfToken(options) {
    var xsrfToken = getXsrfCookie();
    if (xsrfToken) {
        options.headers["X-XSRF-TOKEN"] = xsrfToken;
    }

    return options;
}

function getXsrfCookie() {
    var matches = document.cookie.match(/\bXSRF-TOKEN=([^\s;]+)/);
    try {
        return (matches && decodeURIComponent(matches[1]));
    } catch (decodeError) {
        return ("");
    }
}

function addContentType(options) {
    if (options.files && options.files.length && options.files[0]) {
        options.headers["Content-Type"] = void 0;
    } else if (options.method !== RequestMethod.Get) {
        options.headers["Content-Type"] = "application/json; charset=UTF-8";
    }

    return options;
}

function makeRequest(req, options) {
    req = applyMethod(req, options);
    req = applyHeaders(req, options);

    return req;
}

function applyHeaders(req, options) {
    for (let key of Object.keys(options.headers)) {
        req = req.set(key, options.headers[key]);
    }

    return req;
}

function sendData(req, options) {
    if (options.files && options.files.length && options.files[0]) {
        const formData = new FormData();
        formData.append("data", JSON.stringify(options.data, null, 2));
        for (let i = 0; i < options.files.length; i++) {
            let file = options.files[i];
            let isBlob = file instanceof Blob;
            if (isBlob && 'fileName' in file) {
                file = new File([file], file.fileName, {type: file.type});
            }

            formData.append("file" + i, file);
        }

        return req.send(formData);
    }

    return req.send(options.data);
}

function applyMethod(req, options) {
    switch (options.method) {
        case RequestMethod.Post:
            return sendData(req.post(options.url), options);
        case RequestMethod.Put:
            return sendData(req.put(options.url), options);
        case RequestMethod.Delete:
            return req.del(options.url);
        default:
            return req.get(options.url);
    }
}

export default request;